import * as types from '../actions/types';
import * as request from '../utils/request';
import config from '../config';
import mergeRequestsWrapper from './mergeRequestsWrapper'
import toastr from 'toastr';

export function getStudentsSuccess(students) {
  return {
    type: types.GET_STUDENTS_SUCCESS,
    payload: students
  };
}
export function getStudentByIdSuccess(student) {
  return {
    type: types.GET_STUDENT_BY_ID_SUCCESS,
    payload: student
  };
}

export function getAllStudentCoursePreferenceSuccess(preferences) {
  return {
    type: types.GET_ALL_STUDENT_COURSES_PREFERENCE_SUCCESS,
    payload: preferences.results || []
  };
}

export function getAllOverridesSuccess(overrides) {
  return {
    type: types.GET_ALL_STUDENT_OVERRIDES,
    payload: overrides
  };
}
export function getStudentRestrictionsSuccess(restrictions) {
  return {
    type: types.GET_ALL_STUDENT_RESTRICTIONS,
    payload: restrictions
  };
}

export function putStudentCoursesToStateSuccess(courses) {
  return {
    type: types.PUT_STUDENTS_COURSES_TO_STATE,
    payload: courses
  };
}

export function getLinksSuccess(links) {
  return {
    type: types.GET_LINKS_SUCCESS,
    payload: links
  };
}
export function getTopkSuccess(topks) {
  return {
    type: types.GET_TOPK_SUCCESS,
    payload: topks
  };
}

export function getAssignmentsSuccess(assignments) {
  return {
    type: types.GET_ASSIGNMENTS_SUCCESS,
    payload: assignments
  };
}

export function getWaitlistSuccess(payload) {
  return {
    type: types.GET_WAITLIST_SUCCESS,
    payload
  };
}

export function getAllStudents() {
  let runName = localStorage.getItem('run');
  let students = [];

  return (dispatch) => {
    // dispatch(getStudentsSuccess([]));
    return new Promise(function(resolve, reject) {
      function getStudents(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(student => {
              students.push(student);
            });
            if (res.data.next == null) {
              dispatch(getStudentsSuccess(students));
              return resolve();
            } else {
              getStudents(res.data.next);
            }
          })
          .catch(err => {
            console.log('err', err);
            return reject();
          });
      }

      getStudents('/runs/' + runName + '/students/');
    });
  };
}

export function getStudentById(id, isAStudent) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/students/' + id + '/')
        .then(res => {
          dispatch(getStudentByIdSuccess(res.data));
          if (!isAStudent)
            dispatch(getAllStudentCoursePreferences(id));
          return resolve(res.data);
        })
        .catch(() => {
          return reject();
        });
    });
    return promise;
  };
}

export function getAllStudentCoursePreferences(id) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/students/' + id + '/preferences/')
        .then(res => {
          dispatch(getAllStudentCoursePreferenceSuccess(res.data));
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          return reject();
        });
    });
  };
}

export function getStudentWaitlists(studentId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/students/' + studentId + '/waitlists/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function getStudentAssignments(studentId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/students/' + studentId + '/assignments/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}


export function createStudent(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let student = Object.assign({}, obj);
      if (student.base_budget) {
        student.base_budget = student.base_budget * 100;
      }
      student.user = {
        email: ''
      };
      student.user.email = student.email.toLowerCase();
      delete student.id;
      delete student.email;
      request
        .req('POST', '/runs/' + runName + '/students/', student)
        .then(res => {
          toastr.success('Item Added Successfully.');
          return resolve(res.data);
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function putStudent(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let student = Object.assign({}, obj);
      if (student.base_budget) {
        student.base_budget = student.base_budget * 100;
      }
      if (student.effective_budget) {
        student.effective_budget = student.effective_budget * 100;
      }
      request
        .req('PUT', '/runs/' + runName + '/students/' + obj.id + '/', student)
        .then(res => {
          toastr.success('Item Changed Successfully.');
          return resolve(res.data);
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function deleteStudent(id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/students/' + id + '/')
        .then(() => {
          toastr.success('Student Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('Error Deleting Student.');
          return reject();
        });
    });
    return promise;
  };
}

export function getAllStudentOverrides(studentId) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      let overrides = {
        run_lock_overrides: [],
        run_conflict_overrides: [],
        run_requirement_overrides: [],
        group_lock_overrides: [],
        group_conflict_overrides: [],
        group_requirement_overrides: []
      };
      let a = request.req('GET', '/runs/' + runName + '/students/' + studentId + '/run-lock-overrides/').then(res => {
        if (res.data.count > 0) {
          res.data.results.map(r => {
            overrides.run_lock_overrides.push(r);
          });
        }
      });
      let b = request
        .req('GET', '/runs/' + runName + '/students/' + studentId + '/run-conflict-overrides/')
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.map(r => {
              overrides.run_conflict_overrides.push(r);
            });
          }
        });
      let c = request
        .req('GET', '/runs/' + runName + '/students/' + studentId + '/run-requirement-overrides/')
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.map(r => {
              overrides.run_requirement_overrides.push(r);
            });
          }
        });
      let d = request.req('GET', '/runs/' + runName + '/students/' + studentId + '/group-lock-overrides/').then(res => {
        if (res.data.count > 0) {
          res.data.results.map(r => {
            overrides.group_lock_overrides.push(r);
          });
        }
      });
      let e = request
        .req('GET', '/runs/' + runName + '/students/' + studentId + '/group-conflict-overrides/')
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.map(r => {
              overrides.group_conflict_overrides.push(r);
            });
          }
        });
      let f = request
        .req('GET', '/runs/' + runName + '/students/' + studentId + '/group-requirement-overrides/')
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.map(r => {
              overrides.group_requirement_overrides.push(r);
            });
          }
        });

      Promise.all([a, b, c, d, e, f])
        .then(() => {
          dispatch(getAllOverridesSuccess(overrides));
          return resolve();
        })
        .catch(() => {
          reject();
        });
    });
    return promise;
  };
}

export function deleteOverride(id, type, studentId) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    request
      .req('DELETE', '/runs/' + runName + '/students/' + studentId + '/' + type + '/' + id + '/')
      .then(() => {
        toastr.success('Release deleted successfully');
        dispatch(getAllStudentOverrides(studentId));
      })
      .catch(() => {
        toastr.error('Something gone wrong.');
      });
  };
}

export function getAllStudentRestrictions(studentId) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      let restrictions = {
        group_locks: [],
        group_conflicts: [],
        group_requirements: [],
        run_locks: [],
        run_conflicts: [],
        run_requirements: []
      };

      // Create array of promises for each restriction type
      let a = request.req('GET', `/runs/${runName}/students/${studentId}/group-locks/`)
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.forEach(r => {
              restrictions.group_locks.push(r);
            });
          }
        });

      let b = request.req('GET', `/runs/${runName}/students/${studentId}/group-conflicts/`)
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.forEach(r => {
              restrictions.group_conflicts.push(r);
            });
          }
        });

      let c = request.req('GET', `/runs/${runName}/students/${studentId}/group-requirements/`)
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.forEach(r => {
              restrictions.group_requirements.push(r);
            });
          }
        });

      let d = request.req('GET', `/runs/${runName}/students/${studentId}/run-conflicts/`)
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.forEach(r => {
              restrictions.run_locks.push(r);
            });
          }
        });

      let e = request.req('GET', `/runs/${runName}/students/${studentId}/run-requirements/`)
        .then(res => {
          if (res.data.count > 0) {
            res.data.results.forEach(r => {
              restrictions.run_requirements.push(r);
            });
          }
        });

      // Wait for all requests to complete
      Promise.all([a, b, c, d, e])
        .then(() => {
          dispatch(getStudentRestrictionsSuccess(restrictions));
          return resolve();
        })
        .catch(() => {
          reject();
        });
    });
    return promise;
  };
}

export function addStudentRelease(restrictionId, studentId, overrideType) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let obj = {};
    switch (overrideType) {
      case config.run_locks:
        obj.run_lock = restrictionId;
        break;
      case config.run_conflicts:
        obj.run_conflict = restrictionId;
        break;
      case config.run_requirements:
        obj.run_requirement = restrictionId;
        break;
      case config.group_locks:
        obj.student_group_lock = restrictionId;
        break;
      case config.group_conflicts:
        obj.student_group_conflict = restrictionId;
        break;
      case config.group_requirements:
        obj.student_group_requirement = restrictionId;
        break;
      default:
        obj = null;
    }
    request
      .req('POST', '/runs/' + runName + '/students/' + studentId + '/' + overrideType + '/', obj)
      .then(() => {
        toastr.success('Release added successfully');
        dispatch(getAllStudentOverrides(studentId));
        dispatch(getAllStudentRestrictions(studentId));
      })
      .catch(err => {
        console.log('error', err);
      });
  };
}

export const getStudent = mergeRequestsWrapper(function getStudent() {
  let runName = localStorage.getItem('run') || localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/student-info/')
        .then(res => {
          dispatch(getStudentById(res.data.id, true));
          return resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          return reject();
        });
    });
    return promise;
  };
})

export function getLinks() {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
  let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/limit-preferences/')
        .then(res => {
          dispatch(getLinksSuccess(res.data.results));
          return resolve(res.data);
        })
        .catch(err => {
          console.log('err', err);
          return reject();
        });
    });
    return promise;
  };
}

export function updateLinks(requestMethod, open_edit_api, obj) {
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req(requestMethod, open_edit_api, obj)
        .then((res) => {
          dispatch(getLinks());
          return resolve(res);
        })
        .catch(err => {
          console.log('err', err);
          return reject();
        });
    });
    return promise;
  };
}

export function deleteLinks(id) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve) => {
      request
        .req('DELETE', '/runs/' + runName + '/limit-preferences/' + id + '/')
        .then(() => {
          dispatch(getLinks());
          toastr.success('Rule deleted successfully');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('Rule is not deleted');
          return resolve();
        });
    });
    return promise;
  };
}

export function runSatisfyStatusCheck(url) {
  return (/*dispatch*/) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', url)
        .then(res => {
          return resolve(res.data)
        })
        .catch(function (err) {
          console.log('ERROR', err.message);
          toastr.error('Problem with getting status.');
          return reject();
        });
    })
    return promise
  }
}

export function runSatisfy(studentId) {
  console.debug(`[runSatisfy] - ${JSON.stringify(studentId, null, 2)}`)
  const runName = localStorage.getItem('run')
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/students/${studentId}/satisfy/`)
        .then(res => {
          return resolve(res.data)
        })
        .catch(function (err) {
          console.log('ERROR', err.message);
          toastr.error('Problem with getting status.');
          return reject();
        });
    })
    return promise
  }
}

export function topk() {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/topk/')
        .then(res => {
          let time = +localStorage.getItem('topkTime') || 1000;

          function checkStatus(url) {
            request.req('GET', url).then(res => {
              if (res.data.status == 'success') {
                dispatch(getTopkSuccess(res.data.output));
                localStorage.removeItem('topkTime');
                localStorage.removeItem('topkUrl');
                return resolve();
              } else if (res.data.status == 'error') {
                toastr.error('Cannot create schedules');
                localStorage.removeItem('topkTime');
                localStorage.removeItem('topkUrl');
                return resolve();
              } else {
                if (time < 120000) {
                  time += 1000;
                  localStorage.setItem('topkTime', time);
                  setTimeout(() => {
                    checkStatus(url);
                  }, 1000);
                } else {
                  localStorage.removeItem('topkTime');
                  localStorage.removeItem('topkUrl');
                  return reject();
                }
              }
            });
          }

          localStorage.setItem('topkUrl', res.data.url);
          checkStatus(res.data.url);
        })
        .catch(function(err) {
          console.log('ERROR', err.message);
          toastr.error('Problem with schedules.');
          return reject();
        });
    });
    return promise;
  };
}

export function continueTopk(statusUrl) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      let time = +localStorage.getItem('topkTime');

      function checkStatus(url) {
        request.req('GET', url).then(res => {
          if (res.data.status == 'success') {
            localStorage.removeItem('topkTime');
            localStorage.removeItem('topkUrl');

            return resolve();
          } else if (res.data.status == 'error') {
            localStorage.removeItem('topkTime');
            localStorage.removeItem('topkUrl');
            return resolve();
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('topkTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 2000);
            } else {
              localStorage.removeItem('topkTime');
              localStorage.removeItem('topkUrl');
              return reject();
            }
          }
        });
      }

      checkStatus(statusUrl);
    });
    return promise;
  };
}

export function setTarget(obj) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    dispatch(
      getStudentByIdSuccess({
        id: null
      })
    );
    request
      .req('POST', '/runs/' + runName + '/set-target/', obj)
      .then(res => {
        dispatch(getStudentByIdSuccess(res.data));
      })
      .catch(err => {
        console.log('error', err);
      });
  };
}

export function emulateStudent(id) {
  const runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/students/${id}/emulate/`)
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
    return promise;
  };
}

export const getAssignment = () => {
  const runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', `/runs/${runName}/assignments/`)
        .then(res => {
          dispatch(getAssignmentsSuccess(res.data.results));
          resolve(res.data)
        })
        .catch(err => {
          return reject(err);
        });
    });
    return promise;
  };
};


export const getWaitlist = () => {
  const runName = localStorage.getItem('run');
  return (dispatch) => {
    dispatch({type: types.GET_WAITLIST_START});

    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', `/runs/${runName}/adds/`)
        .then(res => {
          dispatch(getWaitlistSuccess(res.data.results));
          return resolve(res.data.results)
        })
        .catch(err => {
          return reject(err);
        });
    });
    return promise;
  };
}

export const exportStudentList = () => {
  const runName = localStorage.getItem('run');
  return () => {

    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/students/export/`)
        .then(res => {
          if (res.status === 200) {
            return resolve(res.data);
          }
          return reject('File error');
        })
        .catch(err => {
          return reject(err);
        });
    });
    return promise;
  };
}


// WEBPACK FOOTER //
// ./src/actions/studentsActionCreators.js